
import { useEffect, useState } from "react";
import { useReminderContext } from "../ReminderContext";
import redpinIcon from "../img/pin_red.svg";


const TaskReminderInfo = () => {
  const { reminderStatus, reminderCount } = useReminderContext();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (["R","Y","G"].includes(reminderStatus)) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [reminderStatus]);

  if (!visible) return null;
    
  return ( 
    <span style={{marginLeft:'5px'}}>
      <span><img style={{width:'11px', height:'11px', display:'inline-block', marginBottom:'1px', marginRight:'4px' }} src={redpinIcon} alt="" /></span>
      {reminderCount > 0 && (
       <span>({reminderCount})</span>
      )}
    </span>


  );
};

export default TaskReminderInfo;